import svgData from "./svgData";
import { PathElement } from "../../../svgHelpers";
import type { SVGProps, SVGElementProps } from "../../../types";

const GenericFile: SVGProps = (props: SVGElementProps) => (
  <>
    <PathElement {...props} path={svgData.path.d1} clipRule={"evenodd"} fillRule="evenodd" />
    <PathElement {...props} path={svgData.path.d3} />
    <PathElement {...props} path={svgData.path.d4} />
    <PathElement {...props} path={svgData.path.d5} />
    <PathElement {...props} path={svgData.path.d6} />
  </>
);

export default GenericFile;
